import { gql } from "@apollo/client";
import { ConsolidationTaskOption } from "../types/ConsolidationTypes";

export const GET_AVAILABLE_CONSOLIDATION_TASKS = gql`
  query GetAvailableConsolidationTasks($warehouseId: Long!, $type: Int!) {
    getAvailableConsolidationTasks(warehouseId: $warehouseId, type: $type) {
      taskId
      displayName
      hubName
      whsName
      available
    }
  }
`;

export interface GetAvailableConsolidationTasksVariables {
  warehouseId: string;
  type: number;
}

export interface GetAvailableConsolidationTasksResponse {
  getAvailableConsolidationTasks: ConsolidationTaskOption[];
}